/* eslint-disable prefer-destructuring */
import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const BasketList = styled.div<SpaceProps>`
    width: 100%;
    ${space};
`;

export const BasketListItem = styled.div`
    display: flex;
    align-items: center;
    gap: ${theme.space[1]}px;
    padding-top: ${theme.space[1]}px;
    padding-bottom: ${theme.space[1]}px;
    border-bottom: 1px solid ${theme.colors.platinumLight};
    &:last-child {
        border-bottom: 0;
    }
`;

export const ListItemLabel = styled.div`
    display: flex;
    color: ${theme.colors.midnight};
`;

export const ListItemLabelText = styled.div`
    font-family: ${theme.fonts.book};
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${theme.colors.midnight};
`;

export const ActionWrapper = styled.div`
    display: flex;
    margin-left: ${theme.space[1]}px;
    line-height: 0.8;

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[1]}px;
    }
`;

export type BasketListItemValueProps = {
    hasPrice?: boolean;
    hasRemoveButton?: boolean;
};

export const ListItemValue = styled.div<BasketListItemValueProps>`
    display: flex;
    gap: ${theme.space[1]}px;
    position: relative;
    flex: 1;
    align-items: center;
    align-self: flex-start;
    justify-content: flex-end;
    font-family: ${theme.fonts.regular};
    font-size: 1.4rem;
    line-height: 2rem;
    text-align: end;
    color: ${theme.colors.midnight};
    white-space: nowrap;
    span {
        align-self: flex-end;
    }
`;
